import { useEffect, useState } from "react";
import { Container, Grid } from "@material-ui/core";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import StructureFields from "components/_refactor/fields/structure";
import FilterCard from "components/_refactor/filter-card";
import HeaderClientes from "components/_refactor/headers/clients";
import InputText from "components/_refactor/text/input";
import TableFranquias from "./components/table-franquias";
import DialogCreateEdit from "./components/dialog-create-edit";

export default function FranquiasAdmPage() {
  const [structureFilters, setStructureFilters] = useState({});
  const [structureLoading, setStructureLoading] = useState([]);
  const [schemaBaseSeta, setSchemaBaseSeta] = useState("");
  const [idFranquiaConfiguracao, setIdFranquiaConfiguracao] = useState("");
  const [searching, setSearching] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const [data, setData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedFranchise, setSelectedFranchise] = useState(null);

  const snackbar = useSnackbar();

  const handleSearch = async () => {
    setSearching(true);
    const params = {
      idPessoaLoja: structureFilters?.idLoja || "",
      idGrupoEconomico: structureFilters?.idGrupoEconomico || "",
      schemaBaseSeta: schemaBaseSeta || "",
      idFranquiaConfiguracao: idFranquiaConfiguracao || "",
    };
    try {
      const response = await Api.get(
        "franchise-config-list",
        "configuracoesOmni",
        "?" + new URLSearchParams(params),
        true
      );
      setData(response.Result);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar as franquias: " + error.message, {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setData([]);
    setSchemaBaseSeta("");
    setIdFranquiaConfiguracao("");
    setTimeout(() => {
      setClearFilters(false);
    }, 300);
  };

  const handleEdit = (franchise) => {
    setSelectedFranchise(franchise);
    setDialogOpen(true);
  };

  const handleCloseDialog = (shouldRefresh) => {
    setDialogOpen(false);
    setSelectedFranchise(null);
    if (shouldRefresh) {
      handleSearch();
    }
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <>
      <HeaderClientes
        section="Configurações de Franquia"
        subsection="Administração"
      />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearch}
          searching={searching}
          handleClearFilters={handleClearFilters}
          disabled={searching}
        >
          <StructureFields
            clearFilters={clearFilters}
            onStructureFieldsChange={setStructureFilters}
            disableAll={!!structureLoading.length}
            onStructureFieldsLoad={setStructureLoading}
            requiredFields={["store"]}
            hideFields={["brand", "channel", "representative"]}
            handleSearch={() => {}}
            franquias
          />
          <Grid item xs={12} md={3}>
            <InputText
              label="Schema Base Seta"
              value={schemaBaseSeta}
              onChange={(e) => setSchemaBaseSeta(e.target.value)}
              disabled={searching}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <InputText
              label="Id da Franquia"
              value={idFranquiaConfiguracao}
              onChange={(e) => setIdFranquiaConfiguracao(e.target.value)}
              disabled={searching}
              type="number"
              InputProps={{
                inputProps: {
                  min: 0,
                },
              }}
            />
          </Grid>
        </FilterCard>
        <TableFranquias
          data={data}
          onEdit={handleEdit}
          onCreate={() => setDialogOpen(true)}
        />
      </Container>
      {dialogOpen && (
        <DialogCreateEdit
          onClose={handleCloseDialog}
          franchise={selectedFranchise}
        />
      )}
    </>
  );
}
